<template>
  <Modal v-model="visible" title="批量编辑" width="680">
    <Form :label-width="130">
      <Form-item label="操作范围">
        <Radio-group v-model="form.scope" @on-change="onScopeChange">
          <Radio label="IDS">勾选题目 ID（{{selectedCount}}）</Radio>
          <Radio label="LEVEL">按级别</Radio>
          <Radio label="TYPE">按题型</Radio>
        </Radio-group>
      </Form-item>
      <Form-item v-if="form.scope === 'IDS'" key="scope-ids" label="题目 ID">
        <Input v-model="form.ids" type="textarea" :rows="3"
               placeholder="已勾选会自动填入该行版本 ID，也可逗号或换行补充"></Input>
      </Form-item>
      <Form-item v-if="form.scope === 'LEVEL'" key="scope-level" label="级别">
        <Select v-model="form.levelCodes" multiple placeholder="选择一个或多个级别">
          <Option v-for="lv in levels" :value="lv" :key="lv">{{lv}}</Option>
        </Select>
      </Form-item>
      <Form-item v-if="form.scope === 'TYPE'" key="scope-type" label="题型">
        <Select v-model="form.questionType" filterable clearable placeholder="选择题库中的题型">
          <Option v-for="t in questionTypes" :value="t" :key="t">{{questionTypeLabel(t, typeSkill)}}</Option>
        </Select>
      </Form-item>
      <Form-item v-if="bank === 'comp' && form.scope !== 'IDS'" label="技能">
        <Select v-model="form.skill" clearable placeholder="不选则该级别/题型全部技能" @on-change="loadQuestionTypes">
          <Option value="Listening">听力 Listening</Option>
          <Option value="Reading">阅读 Reading</Option>
          <Option value="Writing">写作 Writing</Option>
        </Select>
      </Form-item>
      <Form-item label="英文指令">
        <Checkbox v-model="form.updateEn">修改 question_direction</Checkbox>
        <Input v-if="form.updateEn" v-model="form.instructionEn" type="textarea" :rows="2"
               placeholder="将覆盖选中题目当前版本的英文指令" style="margin-top:8px"></Input>
      </Form-item>
      <Form-item label="中文指令">
        <Checkbox v-model="form.updateCn">修改 question_direction_chinese</Checkbox>
        <Input v-if="form.updateCn" v-model="form.instructionCn" type="textarea" :rows="2"
               placeholder="将覆盖选中题目当前版本的中文指令" style="margin-top:8px"></Input>
      </Form-item>
      <Form-item label="状态">
        <Radio-group v-model="form.statusAction">
          <Radio label="none">不改状态</Radio>
          <Radio label="online">上线</Radio>
          <Radio label="offline">下线</Radio>
          <Radio label="discard">废弃</Radio>
        </Radio-group>
        <p class="mex-dim-hint">已上线须先下线再废弃。指令改当前版本，不升版本。</p>
      </Form-item>
    </Form>
    <div slot="footer">
      <Button @click="visible = false">取消</Button>
      <Button type="primary" :loading="saving" @click="submit">确定</Button>
    </div>
  </Modal>
</template>

<script>
import { questionTypeLabel } from './mex-question-type'

export default {
  name: 'MexQuestionBatchModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    bank: {
      type: String,
      default: 'comp'
    },
    selectedRows: {
      type: Array,
      default () {
        return []
      }
    },
    skill: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      saving: false,
      form: this.emptyForm(),
      questionTypes: [],
      levels: ['L1.0', 'L2.0', 'L3.0', 'L4.0', 'L5.0', 'L6.0', 'L7.0', 'L8.0']
    }
  },
  computed: {
    visible: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    },
    selectedCount () {
      return this.selectedIds().length
    },
    typeSkill () {
      if (this.bank === 'speak') return 'Speaking'
      return this.form.skill || this.skill || ''
    }
  },
  watch: {
    value (val) {
      if (val) {
        this.form = this.emptyForm()
        this.form.ids = this.selectedIds().join(',')
        this.form.skill = this.skill || ''
        if (this.form.ids) {
          this.form.scope = 'IDS'
        }
        this.loadQuestionTypes()
      }
    }
  },
  methods: {
    questionTypeLabel,
    emptyForm () {
      return {
        scope: 'IDS',
        ids: '',
        levelCodes: [],
        questionType: '',
        skill: '',
        updateEn: false,
        instructionEn: '',
        updateCn: false,
        instructionCn: '',
        statusAction: 'none'
      }
    },
    onScopeChange (scope) {
      if (scope !== 'LEVEL') {
        this.form.levelCodes = []
      }
      if (scope !== 'TYPE') {
        this.form.questionType = ''
      }
    },
    loadQuestionTypes () {
      let url = this.bank === 'speak' ? '/mex/speak/questions/types' : '/mex/comp/questions/types'
      let payload = {}
      if (this.bank === 'comp' && this.form.skill) {
        payload.skill = this.form.skill
      }
      this.$http.post(url, payload).then(res => {
        if (res.status === 'ok') {
          this.questionTypes = res.data || []
        } else {
          this.questionTypes = []
        }
        if (this.form.questionType && this.questionTypes.indexOf(this.form.questionType) < 0) {
          this.form.questionType = ''
        }
      }).catch(() => {
        this.questionTypes = []
      })
    },
    selectedIds () {
      let rows = this.selectedRows || []
      let ids = []
      let seen = {}
      rows.forEach(row => {
        if (!row) return
        let id = row.currentVersionId != null ? row.currentVersionId : row.id
        if (id != null && !seen[id]) {
          seen[id] = true
          ids.push(id)
        }
      })
      return ids
    },
    escapeHtml (s) {
      return String(s || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
    },
    scopeHint () {
      if (this.form.scope === 'IDS') {
        return '将改这些勾选/填写的版本，共 ' + (this.form.ids ? this.form.ids.split(/[,;\s]+/).filter(Boolean).length : 0) + ' 个 ID'
      }
      if (this.form.scope === 'LEVEL') {
        return '将改级别 ' + (this.form.levelCodes || []).join('、') + ' 下全部当前版本'
      }
      return '将改题型「' + this.form.questionType + '」下全部当前版本'
    },
    submit () {
      if (this.form.scope === 'IDS' && !this.form.ids) {
        this.$Message.warning('请勾选或填写题目 ID')
        return
      }
      if (this.form.scope === 'LEVEL' && (!this.form.levelCodes || !this.form.levelCodes.length)) {
        this.$Message.warning('请选择级别')
        return
      }
      if (this.form.scope === 'TYPE' && !this.form.questionType) {
        this.$Message.warning('请选择题型')
        return
      }
      if (!this.form.updateEn && !this.form.updateCn && (!this.form.statusAction || this.form.statusAction === 'none')) {
        this.$Message.warning('请至少勾选改指令或选择上线/下线/废弃')
        return
      }
      this.$Modal.confirm({
        title: '确认批量编辑',
        content: this.scopeHint() + '。已上线须先下线再废弃。',
        onOk: () => this.doSubmit()
      })
    },
    doSubmit () {
      let url = this.bank === 'speak' ? '/mex/speak/questions/batch' : '/mex/comp/questions/batch'
      let payload = {
        scope: this.form.scope,
        ids: this.form.ids,
        levelCode: (this.form.levelCodes || []).join(','),
        questionType: this.form.questionType,
        skill: this.form.skill,
        updateInstructionEn: this.form.updateEn ? 1 : 0,
        instructionEn: this.form.instructionEn,
        updateInstructionCn: this.form.updateCn ? 1 : 0,
        instructionCn: this.form.instructionCn,
        statusAction: this.form.statusAction === 'none' ? '' : this.form.statusAction
      }
      this.saving = true
      this.$http.post(url, payload).then(res => {
        this.saving = false
        if (res.status === 'ok') {
          this.showResult(res.data)
          this.visible = false
          this.$emit('success')
        } else {
          this.$Message.error(res.msg || '批量编辑失败')
        }
      }).catch(() => {
        this.saving = false
        this.$Message.error('批量编辑失败')
      })
    },
    showResult (d) {
      let data = d || {}
      let msg = '成功 ' + (data.successCount || 0) + '，失败 ' + (data.failCount || 0)
      let rows = data.failRows || []
      if (rows.length) {
        let body = rows.map(r => this.escapeHtml(r)).join('<br>')
        this.$Modal.warning({
          title: '批量编辑结果',
          width: 720,
          content: this.escapeHtml(msg) + '<br><pre style="max-height:320px;overflow:auto;white-space:pre-wrap">' + body + '</pre>'
        })
      } else {
        this.$Message.success(data.message || msg)
      }
    }
  }
}
</script>

<style scoped>
.mex-dim-hint {
  margin: 8px 0 0;
  color: #808695;
  line-height: 20px;
}
</style>



// WEBPACK FOOTER //
// MexQuestionBatchModal.vue?758eb5dd